module.exports = __webpack_public_path__ + "static/img/data1.7ad55082.png";